import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography, useTheme, } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
export const VideoPreviewModal = ({ open, onClose, insights, videoSrc, posterSrc, }) => {
    const theme = useTheme();
    const [showButtonPlay, setShowButtonPlay] = useState(true);
    const videoRef = useRef(null);
    const handlePlay = () => {
        if (videoRef.current) {
            videoRef.current.play();
            setShowButtonPlay(false);
        }
    };
    useEffect(() => {
        if (!open)
            return;
        setShowButtonPlay(true);
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
        }
    }, [open]);
    return (_jsxs(Dialog, { open: open, onClose: onClose, maxWidth: false, children: [_jsxs(DialogTitle, { children: ["Video Preview", _jsx(IconButton, { onClick: onClose, sx: {
                            top: 8,
                            right: 8,
                            position: 'absolute',
                        }, children: _jsx(CloseIcon, {}) })] }), _jsx(DialogContent, { children: _jsxs(Box, { border: 1, padding: "16px", maxWidth: "542px", borderRadius: "4px", borderColor: theme.palette.divider, children: [_jsxs(Box, { width: "542px", height: "452px", overflow: "hidden", position: "relative", children: [_jsx("video", { muted: true, ref: videoRef, src: videoSrc, poster: posterSrc, controls: !showButtonPlay, onPlay: () => setShowButtonPlay(false), style: { width: '100%', height: '100%', objectFit: 'cover' } }), showButtonPlay && (_jsx(IconButton, { onClick: handlePlay, sx: {
                                        top: '50%',
                                        left: '50%',
                                        padding: 0,
                                        fontSize: 64,
                                        position: 'absolute',
                                        transform: 'translate(-50%, -50%)',
                                    }, children: _jsx(PlayArrowIcon, { fontSize: "inherit", sx: { color: theme.palette.background.default } }) }))] }), _jsxs(Box, { marginTop: "10px", children: [_jsx(Typography, { fontSize: "13px", fontWeight: 500, lineHeight: "18px", paddingLeft: "20px", color: theme.palette.grey[700], children: "Reviewer Input Summary" }), _jsx(Stack, { gap: "8px", marginTop: "6px", children: insights.map((insight, index) => (_jsxs(Stack, { gap: "10px", direction: "row", paddingLeft: "5px", children: [_jsx(Typography, { fontSize: "20px", fontWeight: 700, color: theme.palette.text.primary, children: "\u2022" }), _jsx(Typography, { fontSize: "13px", fontWeight: 700, lineHeight: "24px", letterSpacing: "0.15px", color: theme.palette.text.primary, children: insight })] }, index))) })] })] }) })] }));
};
